import { useHeaderHeight } from "@dogstrust/dt-web-core-lib-front-end/src/hooks/useHeaderHeight";
import * as styles from "./Layout.module.scss";

import Footer, {
	MinimalFooter,
} from "@dogstrust/dt-web-core-lib-front-end/src/containers/Footer/uk";
import { MinimalHeader } from "@dogstrust/dt-web-core-lib-front-end/src/containers/Header/uk";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";

interface MinimalLayoutProps {
	children: React.ReactNode;
	outsideLayoutChildren?: React.ReactNode;
	isMaintenance?: boolean;
	footerCustomComponent?: React.ReactNode;
}
export const MinimalLayout: React.FC<MinimalLayoutProps> = ({
	children,
	outsideLayoutChildren,
	footerCustomComponent,
	isMaintenance = false,
}) => {
	const headerHeight = useHeaderHeight();

	const {
		footer: { nodes: footerItems },
	} = useStaticQuery<Queries.MinimalLayoutQuery>(BUILD_QUERY);

	const footerLinks: DogsTrust.Link[] = footerItems
		.filter((link) => !link.drupal_parent_menu_item)
		.sort((a, b) => a.weight - b.weight)
		.map((link) => ({ title: link.title, url: link.link.uri }));

	return (
		<>
			<div className={styles.layoutcontainer}>
				<MinimalHeader />
				<div className={styles.contentwrapper}>
					<main
						id="main-content"
						className={styles.inner}
						style={{
							paddingTop: headerHeight,
						}}
						// Resolves skip to content focus issue on iOS
						tabIndex={-1}
					>
						{children}
						{isMaintenance ? (
							<MinimalFooter />
						) : (
							<Footer
								footerLinks={footerLinks}
								customComponent={footerCustomComponent}
							/>
						)}
					</main>
				</div>
			</div>
			{outsideLayoutChildren}
		</>
	);
};

export default MinimalLayout;

const BUILD_QUERY = graphql`
	query MinimalLayout {
		buildDateTime {
			datetime
		}

		footer: allMenuLinkContentMenuLinkContent(filter: { menu_name: { eq: "footer" } }) {
			nodes {
				title
				description
				link {
					uri
				}
				drupal_parent_menu_item
				weight
			}
		}
	}
`;
